import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { useDeviceSync } from "../hooks/useDeviceSync";

type SyncContextType = ReturnType<typeof useDeviceSync>;

const SyncContext = createContext<SyncContextType | null>(null);

export function SyncProvider({ isAuthenticated, children }: { isAuthenticated: boolean; children: ReactNode }) {
  const sync = useDeviceSync(isAuthenticated);
  return <SyncContext.Provider value={sync}>{children}</SyncContext.Provider>;
}

export function useSync(): SyncContextType {
  const ctx = useContext(SyncContext);
  if (!ctx) throw new Error("useSync must be used within SyncProvider");
  return ctx;
}
